import PropTypes from 'prop-types';
import React, {
  createContext,
  useContext,
  useMemo,
} from 'react';
import { MODULE_NAME } from '../constants/moduleName';
import { THEME_BLUE } from '../constants/themeConstants';

const ConfigContext = createContext(null);

export const ConfigContextProvider = ({
  children,
  theme,
  parentId,
  element,
  maxAdults,
  maxRooms,
  hasLabel,
  maxChildren,
  maxInfants,
  maxCombinedChildrenAndInfants,
  maxTravelersCap,
  maxTravelersPerRoom,
  hasRooms,
  hasInfants,
  hasPets,
  hasChildrenAges,
  value,
  onChange,
  defaultChildAge,
  onToggleVisibility,
  lob,
  defaultValue,
  errors,
}) => {
  const memoized = useMemo(() => ({
    defaultChildAge,
    element,
    hasChildrenAges,
    hasInfants,
    hasPets,
    hasRooms,
    hasLabel,
    maxAdults,
    maxChildren,
    maxCombinedChildrenAndInfants,
    maxTravelersCap,
    maxTravelersPerRoom,
    maxInfants,
    maxRooms,
    moduleId: parentId ? `${MODULE_NAME}-${parentId}` : MODULE_NAME,
    onChange,
    onToggleVisibility,
    theme,
    value,
    lob,
    defaultValue,
    errors,
  }), [
    defaultChildAge,
    element,
    hasChildrenAges,
    hasInfants,
    hasPets,
    hasRooms,
    hasLabel,
    maxAdults,
    maxChildren,
    maxCombinedChildrenAndInfants,
    maxTravelersCap,
    maxTravelersPerRoom,
    maxInfants,
    maxRooms,
    onChange,
    onToggleVisibility,
    parentId,
    theme,
    value,
    lob,
    defaultValue,
    errors,
  ]);

  return (
    <ConfigContext.Provider value={memoized}>
      {children}
    </ConfigContext.Provider>
  );
};

ConfigContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
  defaultChildAge: PropTypes.string,
  maxAdults: PropTypes.number,
  maxChildren: PropTypes.number,
  maxCombinedChildrenAndInfants: PropTypes.number,
  maxTravelersCap: PropTypes.number,
  maxTravelersPerRoom: PropTypes.number,
  maxInfants: PropTypes.number,
  maxRooms: PropTypes.number,
  onChange: PropTypes.func,
  onToggleVisibility: PropTypes.func,
  parentId: PropTypes.string,
  element: PropTypes.string,
  hasChildrenAges: PropTypes.bool,
  hasInfants: PropTypes.bool,
  hasPets: PropTypes.bool,
  hasRooms: PropTypes.bool,
  hasLabel: PropTypes.bool,
  theme: PropTypes.string,
  value: PropTypes.arrayOf(
    PropTypes.shape({})
  ).isRequired,
  lob: PropTypes.string,
  defaultValue: PropTypes.arrayOf(
    PropTypes.shape({})
  ),
  errors: PropTypes.arrayOf(PropTypes.string),
};

ConfigContextProvider.defaultProps = {
  theme: THEME_BLUE,
};

export const useConfigContext = () => {
  const context = useContext(ConfigContext);

  if (!context || Object.keys(context).length === 0) {
    throw new Error('useConfigContext must be used within ConfigContextProvider.');
  }

  return context;
};
